export default __webpack_public_path__ + "static/media/QR.600b6fda.png";